import { Day } from '@/domain/termine/type';
import { DayCell } from '@/domain/termine/features/Calendar/shared/DayCell/DayCell';

interface CalendarWeekProps {
  week: Day[];
}

export function CalendarWeek({ week }: CalendarWeekProps) {
  return (
    <div className="grid grid-cols-7">
      {week.map((day) => (
        <DayCell key={day.format('DD-MM-YYYY')} day={day} />
      ))}
    </div>
  );
}
